import useSelectedOffer from './useSelectedOffer';

export default useSelectedOffer;
